import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useLazyLoad from './useLazyLoad';
const MediaBaseURL = process.env.REACT_APP_BACKEND_API;

export default function LazyLoadImage({ image, albumId, albumName, counter,onClick, translate , index  , startDate}) {
    const [ref, isIntersecting] = useLazyLoad();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <a className="mediaCard"  style={{width: (index == 0 && windowWidth > 768) ? '100%' :(
            ((index == 1  && windowWidth > 768) || (index == 2  && windowWidth > 768))? '25%':
            (index < 7  && windowWidth > 768) ? '20%': 
            'unset')}} ref={ref}>
            {isIntersecting && (
                <img src={MediaBaseURL + image.url} onClick={onClick} alt="ChangeMe" style={{cursor:'pointer' , height: (index == 0 && windowWidth > 768) ? 'unset' :(
                    (index == 1 || index == 2)? 'unset':
                    200) , width: (index == 0  && windowWidth > 768) ? '100%' :(
                        (index == 1 || index == 2)? '100%':
                        'unset')}} />
            )}
            {counter === 0 && (
                <Link to={`/album-details?id=${albumId}`} className="mediaOverLay text-start ps-1 text-white roboto-bold">
                    <span className='d-block w-100 text-start ps-1 text-white' style={{textTransform:'capitalize',fontSize:20}}>
                    {albumName}
                    </span>
                    <span style={{ width: '100%', display: 'block', fontSize:16}} className="mediaViewMore text-start ps-1 text-white roboto-regular">
                    <i
                        className="fa fa-calendar C89C66 me-1"
                       
                    ></i>
                    <span> {startDate}</span>
                    </span>
                </Link>
            )}
        </a>
    );
}
